import { render } from "./TrendingStatButton.vue?vue&type=template&id=46c69d6e&scoped=true"
import script from "./TrendingStatButton.vue?vue&type=script&lang=js"
export * from "./TrendingStatButton.vue?vue&type=script&lang=js"

import "./TrendingStatButton.vue?vue&type=style&index=0&id=46c69d6e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c69d6e"]])

export default __exports__